import React from 'react';

function getVisiblePages(currentPage, totalPages, maxVisiblePages = 7) {
  if (totalPages <= 0) {
    return [];
  }

  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, index) => index);
  }

  const halfWindow = Math.floor(maxVisiblePages / 2);
  const start = Math.max(0, Math.min(currentPage - halfWindow, totalPages - maxVisiblePages));

  return Array.from({ length: maxVisiblePages }, (_, index) => start + index);
}

export default function PaginationControls({
  currentPage,
  totalPages,
  onPageChange,
  disabled = false,
  className = '',
}) {
  if (totalPages <= 1) {
    return null;
  }

  const visiblePages = getVisiblePages(currentPage, totalPages);

  return (
    <div className={`flex items-center justify-between gap-4 px-6 py-4 border-t border-[var(--app-border)] ${className}`.trim()}>
      <button
        type="button"
        onClick={() => onPageChange(Math.max(currentPage - 1, 0))}
        disabled={disabled || currentPage === 0}
        className="px-5 py-2.5 rounded-2xl bg-[rgba(245,245,247,0.9)] font-medium disabled:opacity-40 transition hover:bg-white"
      >
        ← Anterior
      </button>

      <div className="flex items-center gap-2">
        {visiblePages.map((pageNumber) => (
          <button
            key={pageNumber}
            type="button"
            onClick={() => onPageChange(pageNumber)}
            disabled={disabled}
            aria-current={pageNumber === currentPage ? 'page' : undefined}
            className={`w-10 h-10 rounded-xl text-sm font-medium transition ${
              pageNumber === currentPage
                ? 'bg-[var(--app-accent)] text-white shadow-md'
                : 'bg-[rgba(245,245,247,0.9)] text-slate-600 hover:bg-white'
            }`}
          >
            {pageNumber + 1}
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages - 1))}
        disabled={disabled || currentPage + 1 >= totalPages}
        className="px-5 py-2.5 rounded-2xl bg-[rgba(245,245,247,0.9)] font-medium disabled:opacity-40 transition hover:bg-white"
      >
        Siguiente →
      </button>
    </div>
  );
}
